import { render, staticRenderFns } from "./ShowAssessment.vue?vue&type=template&id=998dbf70"
import script from "./ShowAssessment.vue?vue&type=script&lang=js"
export * from "./ShowAssessment.vue?vue&type=script&lang=js"
import style0 from "./ShowAssessment.vue?vue&type=style&index=0&id=998dbf70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports